import { useState } from "react"
import Modal from "../../components/Modal"
import { useAppSelector } from "../../store/store"
import ModalCard from "../../components/ModalCard"
import InputText from "../../components/InputText"
import Button from "../../components/Button"
import TextArea from "../../components/TextArea"
import { updateTeamData } from "../../services/team.services"
import { toast } from "react-toastify"

const UPDATE_TEAM_DATA_PRICE = 0.25
const UpdateTeamDataForm = () => {
    const token = useAppSelector(state => state.token)
    const team = useAppSelector(state => state.team)
    const player = useAppSelector(state => state.player)
    const isMember = player.teams?.find((member) => member.team_id === team.id)

    const [requesting, setRequesting] = useState<boolean>(false)
    const [isOpen, setIsOpen] = useState<boolean>(false)
    const [form, setForm] = useState({
        name: team.name as string,
        description: team.description as string,
    })

    const handleInputChange: React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement> = (event) => setForm({ ...form, [event.target.name]: event.target.value })

    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault()
        setRequesting(true)
        updateTeamData({
            teamId: team.id as string,
            token: token || "",
            ...form
        })
            .then(() => toast.success("¡Actualizado!"))
            .catch((error) => toast.error(error.response.data.message))
            .finally(() => setRequesting(false))
    }


    return (
        <>
            {isMember && isMember.admin && <button className="text-blue-500 self-start" onClick={() => setIsOpen(true)}>Editar</button>}
            <Modal modalOpen={isOpen} set={setIsOpen}>
                <ModalCard>
                    <p className="text-zinc-700 text-xl">Editar datos del equipo</p>

                    <form className="flex flex-col gap-5" onSubmit={handleSubmit}>
                        <InputText
                            type="text"
                            name="name"
                            placeholder="Nombre"
                            onChange={handleInputChange}
                            value={form.name}
                        />

                        <InputText
                            type="text"
                            name="slug"
                            placeholder="Slug"
                            value={team.slug}
                            disabled
                        />

                        <TextArea
                            name="description"
                            placeholder="Descripción"
                            onChange={handleInputChange}
                            value={form.description}
                        ></TextArea>

                        <Button disabled={requesting} spinner={requesting}>Actualizar (CT${UPDATE_TEAM_DATA_PRICE.toFixed(2)})</Button>
                    </form>
                </ModalCard>
            </Modal>
        </>
    )
}

export default UpdateTeamDataForm